/**
 * Classe utilitaire pour gérer les comportements de scroll
 */
export class ScrollUtils {

	static BREAK_POINT_WIDTH = 768;

    /**
     * Récupère les éléments HTML de la liste et de la carte sélectionnée
     * @param container Conteneur de la liste
     * @param card Carte sélectionnée
     */
	static getHtmlElementDetails(container: HTMLElement, card: HTMLElement): { containerRect: DOMRect; cardRect: DOMRect } {
        const containerRect = container.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();

        return { containerRect, cardRect };
    }

    /**
     * Scroll jusqu'à la carte sélectionnée en mode vertical
     * @param container Conteneur de la liste
     * @param card Carte sélectionnée
     */
   static scrollToVertical(container: HTMLElement, card: HTMLElement): void {
       const { containerRect, cardRect } = this.getHtmlElementDetails(container, card);
       const offsetTop = cardRect.top - containerRect.top;

       container.scrollTo({
           top: container.scrollTop + offsetTop,
           behavior: 'smooth'
       });
   }

   /**
     * Scroll jusqu'à la carte sélectionnée en mode horizontal
     * @param container Conteneur de la liste
     * @param card Carte sélectionnée
     */
    static scrollToHorizontal(container: HTMLElement, card: HTMLElement): void {
        const { containerRect, cardRect } = this.getHtmlElementDetails(container, card);
        const offsetLeft = cardRect.left - containerRect.left;

        container.scrollTo({
            left: container.scrollLeft + offsetLeft,
            behavior: 'smooth'
        });
    }

   /**
     * Réinitialise le scroll à la première carte
     */
    static resetScroll(): void {
        const cardContainer = document.getElementById('card-container');
        if (cardContainer) {
            if (window.innerWidth > this.BREAK_POINT_WIDTH) {
                cardContainer.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                cardContainer.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }
    }
}